import { Divider, Grid } from '@material-ui/core';
import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent';
import Masks from '../../providers/Masks';
import Utils from '../../providers/Utils';
import Ws from '../../providers/Ws';


export default class AnalizaVanzariSiClienti extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            clientiAnalizaDeAfisat: [],
            clientiAnalizaTop5: [],
            clientiAnalizaToti: []
        }
    }

    componentDidMount() {
        this.getData()
    }

    ws = new Ws()
    u = new Utils()
    m = new Masks()


    getData = async () => {
        let getClienti = await this.ws.customSelect('select * from fin_import_raport_lunar_clienti_head where isnull(sters,0) != 1 order by an desc', {
            p1: 1
        })

        if (getClienti.Succes) {

            let clientiRows = await this.ws.customSelect('select * from fin_import_raport_lunar_clienti_rows where id_head in (select id from fin_import_raport_lunar_clienti_head where isnull(sters,0) != 1) and isnull(sters,0) != 1', {
                p1: 1
            })



            console.log('getClienti :>> ', getClienti);
            console.log('getClientiRows :>> ', clientiRows);


            let clientiR = [...clientiRows.Content]

            let clientiHead = [...getClienti.Content]


            let clienti = [...new Set(clientiR.map(c => c.localitate))]

            let clientiAnaliza = []



            console.log('clientiHead :>> ', clientiHead);

            for (let i = 0, n = clienti.length; i < n; i++) {

                let client = {
                    nume: clienti[i],
                    analiza: 'Pierdut',
                    analiza_color: '',
                    segmentare: '',
                    segmentare_color: '',
                    sold: 0,
                    zile_depasite: 0

                }

                let filterClienti = clientiR.filter(c => c.localitate === clienti[i])






                console.log('filterClienti :>> ', filterClienti);


                for (let j = 0, m = filterClienti.length; j < m; j++) {





                    if (filterClienti[j].document && filterClienti[j].document.length > 0) {
                        client['sold'] += filterClienti[j].valoare


                        client['zile_depasite'] += this.m.jsDatesDifferenceInDays(new Date(this.u.ParseDataFromSql(filterClienti[j].termen)), new Date()) <= 0 ? 0 : this.m.jsDatesDifferenceInDays(new Date(this.u.ParseDataFromSql(filterClienti[j].termen)), new Date())




                    }
                }




                let filterClientiAnCurent = filterClienti.filter(cA => cA.id_head === clientiHead[0].id)



                let filterAnPrecedent = []

                if (clientiHead.length > 1) {

                    filterAnPrecedent = filterClienti.filter(cA => cA.id_head === clientiHead[1].id)
                }

                console.log('filterClientiAnCurent :>> ', filterClientiAnCurent);
                console.log('filterClientiAnPrecedent :>> ', filterAnPrecedent);

                if (filterClientiAnCurent.length > 0 && filterAnPrecedent.length > 0) {
                    client['analiza'] = this.dictionary.financiar.loial
                    client['analiza_color'] = 'rgb(85 133 27)'
                } else if (filterClientiAnCurent.length > 0 && filterAnPrecedent.length === 0) {
                    client['analiza'] = this.dictionary.financiar.nou
                    client['analiza_color'] = 'rgb(85 133 27)'
                } else {
                    client['analiza'] = this.dictionary.financiar.pierdut
                    client['analiza_color'] = 'rgb(227, 51, 59'
                }


                if (client['zile_depasite'] === 0) {
                    client['segmentare'] = this.dictionary.financiar.bunPlatnic
                    client['segmentare_color'] = 'rgb(85 133 27)'
                } else {
                    client['segmentare'] = this.dictionary.financiar.rauPlatnic
                    client['segmentare_color'] = 'rgb(227, 51, 59'
                }









                clientiAnaliza.push(client)





            }

            let clientiAnalizaToti = [...clientiAnaliza]

            clientiAnalizaToti = clientiAnalizaToti.sort((a, b) => {
                if (a.valoare < b.valoare) {
                    return -1
                } else {
                    return 1
                }
            })


            let clientiAnalizaTop5 = []

            let nTop5 = 5

            for (let i = 0, n = clientiAnalizaToti.length > 5 ? nTop5 : clientiAnalizaToti.length; i < n; i++) {

                clientiAnalizaTop5.push(clientiAnalizaToti[i])
            }


            console.log('clientiAnalizaToti :>> ', clientiAnalizaToti);

            console.log('clientiAnalizaTop5 :>> ', clientiAnalizaTop5);

            this.setState({
                clientiAnalizaDeAfisat: clientiAnalizaTop5,
                clientiAnalizaTop5: clientiAnalizaTop5,
                clientiAnalizaToti: clientiAnalizaToti,
            })



        }
    }


    afiseazaTotiClientii = () => {



        if (this.state.clientiAnalizaDeAfisat.length > 5) {
            console.log('true :>> ');
            
            this.setState({ clientiAnalizaDeAfisat: this.state.clientiAnalizaTop5 })
         
        } else {
            console.log('false :>> ');
            this.setState({ clientiAnalizaDeAfisat: this.state.clientiAnalizaToti })
        }
    }


    render() {
        return (
            <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40 }}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Grid container>
                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                            <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} >{this.dictionary.financiar.analizaVanzariSiClienti} </h5>
                        </Grid>

                        <Grid style={{ paddingTop: 20, textAlign: 'right' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                            <span style={{ textAlign: 'left', paddingLefft: 20, fontSize: 14 }} >{this.dictionary.financiar.top5Clienti} </span>
                        </Grid>

                        <Grid onClick={this.afiseazaTotiClientii} style={{ paddingTop: 20, textAlign: 'right' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                            <span style={{ textAlign: 'left', paddingLefft: 20, textDecoration: 'underline', color: '#94c3f3', fontSize: 14, cursor: 'pointer' }} >{this.dictionary.financiar.afisazaTotiClientii} </span>
                        </Grid>
                    </Grid>



                    <Divider className='pm-divider' />
                </Grid>

                {this.state.clientiAnalizaDeAfisat &&

                    this.state.clientiAnalizaDeAfisat.map((c, idx) => {


                        return (
                            <Grid style={{ marginTop: 20 }} key={idx} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container>
                                    <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                                        <Grid style={{ textAlign: 'left' }} container>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b2b2b2' }}>{this.dictionary.financiar.afiseazaTotiClientii}</span>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 400, color: 'black' }}>{c.nume} </span>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                        <Grid style={{ textAlign: 'left' }} container>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b2b2b2' }}>{this.dictionary.financiar.analiza}</span>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600, color: c.analiza_color }}>{c.analiza} </span>
                                            </Grid>
                                        </Grid>

                                    </Grid>
                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                        <Grid style={{ textAlign: 'left' }} container>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: '#b2b2b2' }}>{this.dictionary.financiar.segmentare}</span>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600, color: c.segmentare_color }}>{c.segmentare} </span>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Divider style={{ marginTop: 20 }} className='pm-divider' />
                            </Grid>
                        )
                    })


                }

                <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <span style={{ fontSize: 12 }}> {this.dictionary.financiar.analizaClientilorText}</span>


                </Grid>


            </Grid>
        );
    }
}